import {applyMiddleware, compose, createStore, Store} from 'redux';
import createSagaMiddleware from 'redux-saga';
import {thunk} from 'redux-thunk';

import { baseApi, webSocketMiddleware } from '#app/api';

import rootReducer from './reducers';
import rootSaga from './sagas';


export default (initialState: Record<string, any> = {}): Store => {
  const sagaMiddleware = createSagaMiddleware()

  const composedEnhancers = compose(applyMiddleware(
    thunk,
    sagaMiddleware,
    webSocketMiddleware,
    baseApi.middleware
  ))

  const store = createStore(rootReducer(), initialState, composedEnhancers)

  sagaMiddleware.run(rootSaga)

  return store;
}
